module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/web_one-8135d99af4905b3bf64040a3ce08cc66.svg";